import React from "react";
import { Button, Card } from "react-bootstrap";
import smallLogo from "../media/small_logo.svg";

export default function MealGrid({
  deleteFromFavorite,
  addToFavorite,
  meal,
  setMeal,
  onAdd,
}) {
  const handleToggleFavorite = () => {
    if (meal.isFavorite) deleteFromFavorite(meal._id);
    else addToFavorite(meal._id);
  };

  return (
    <Card className="glass-panel floating-card d-flex flex-column p-3 meal-card">
      <div className="position-relative mb-2">
        <div
          className="ratio ratio-1x1 rounded"
          style={{
            background: "#f3f6ff",
            border: "1px solid rgba(0,0,0,0.04)",
            overflow: "hidden",
          }}
        >
          <img
            src={meal.image ? meal.image : smallLogo}
            alt={meal.name}
            className="w-100 h-100"
            style={{ objectFit: "cover" }}
            onClick={() => setMeal(meal)}
          />
        </div>
        <Button
          variant={meal.isFavorite ? "primary" : "outline-secondary"}
          size="sm"
          className="rounded-circle d-flex align-items-center justify-content-center favorite-btn"
          onClick={handleToggleFavorite}
        >
          {meal.isFavorite ? (
            <i className="bi bi-bookmark-star-fill" />
          ) : (
            <i className="bi bi-bookmark-star" />
          )}
        </Button>
      </div>
      <div className="flex-grow-1">
        <p
          className="m-0 fw-bold text-dark"
          onClick={() => setMeal(meal)}
          style={{ cursor: "pointer" }}
        >
          {meal.name}
        </p>
        <p
          className="m-0 text-muted small"
          onClick={() => setMeal(meal)}
          style={{ cursor: "pointer" }}
        >
          {meal.subName}
        </p>
      </div>
      <Button
        variant="primary"
        className="mt-3 w-100 justify-content-center text-white"
        style={{ fontSize: "1.2rem", fontWeight: 800, paddingTop: "0.65rem", paddingBottom: "0.65rem" }}
        onClick={() =>
          onAdd({
            name: meal.name,
            price: meal.price,
            mealId: meal._id,
          })
        }
      >
        <i className="bi bi-cart-plus me-2" />
        {meal.price} ₽
      </Button>
    </Card>
  );
}
